function initBusiness() {
  const businessAboutSlider = document.querySelector(".business__about-slider");
  if (!businessAboutSlider) return;

  const businessAboutSliderSwiper = new Swiper(businessAboutSlider, {
    slidesPerView: 5,
    spaceBetween: 20,
    navigation: {
      nextEl: ".business__about-slider .swiper-next-btn",
    },
    breakpoints: {
      0: {
        slidesPerView: 2,
        spaceBetween: 5,
      },
      768: {
        slidesPerView: 3,
        spaceBetween: 10,
      },
      1024: {
        slidesPerView: 4,
        spaceBetween: 10,
      },
      1280: {
        slidesPerView: 5,
        spaceBetween: 20,
      },
    },
  });

  const businessBrandsSlider = document.querySelector(".business__brands-items");
  if (!businessBrandsSlider) return;

  const businessBrandsSliderSwiper = new Swiper(businessBrandsSlider, {
    slidesPerView: 6,
    spaceBetween: 16,
    grid: {
      rows: 3,
    },
    slidesPerGroup: 6,
    navigation: {
      nextEl: ".business__brands-items .swiper-next-btn",
    },
    breakpoints: {
      0: {
        slidesPerView: 2,
        spaceBetween: 5,
        slidesPerGroup: 2,
        grid: null
      },
      768: {
        slidesPerView: 3.2,
        spaceBetween: 16,
        slidesPerGroup: 3.2,
        grid: null
      },
      1024: {
        slidesPerView: 4.5,
        spaceBetween: 16,
        slidesPerGroup: 4.5,
        grid: null
      },
      1280: {
        slidesPerView: 6,
        spaceBetween: 16,
        grid: {
          rows: 3,
        },
        slidesPerGroup: 6,
      }
    }
  });
}

export { initBusiness };
